import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RampGuidancePage from './RampGuidancePage/RampGuidancePage';
import RampGuidanceSubscribePage from './RampGuidanceSubscribePage/RampGuidanceSubscribePage';

const RampGuidanceFeature: FC = () => (
  <Switch>
    <Route path="/maps/ramp-guidance" exact>
      <Redirect to="/maps/ramp-guidance/upcoming-features" />
    </Route>
    <Route path="/maps/ramp-guidance/upcoming-features" exact>
      <RampGuidancePage />
    </Route>
    <Route path="/maps/ramp-guidance/subscribe" exact>
      <RampGuidanceSubscribePage />
    </Route>
  </Switch>
);

export default RampGuidanceFeature;
